#import "~/graphql/fragments/CoreEntryFields.graphql"
#import "~/graphql/fragments/seomatic.graphql"
#import "~/graphql/fragments/Components/Newsletter.graphql"

query Stories($site: [String] = "nl") {
    entry(site: $site, section: "storiesOverview") {
        ...CoreEntryFields
        ...SeomaticFields

        title

        ... on storiesOverview_Entry {
            intro: textPlain
            newsletterBlock {
                
                    ...Newsletter
                
            }
        }
    }

    # load categories for storylist
    entries( site: $site, section: "storyCategories") {
        ... on storyCategory_Entry {
            id
            slug
            title
        }
    }
}
